var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"rounded-xl",attrs:{"outlined":""}},[_c('v-card-text',{staticClass:"text-center"},[_c('h4',{staticClass:"text-overline"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('h3',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm._f("valorBR")(_vm.valor,0))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }